module.exports = __webpack_public_path__ + "c780f857c34468134d83e7bd5e58eb54.pdf";